"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var styles = function styles() {
  return "\n  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n    &.vds-btn-label {\n      position: relative;\n    }\n  }\n\n  &.vds-btn-label {\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    flex: 0 0 auto;\n    justify-content: center;\n    margin: auto;\n    max-width: 100%;\n    overflow-wrap: break-word;\n    padding: 0 1rem;\n    text-align: center;\n    word-break: normal;\n    word-wrap: normal;\n  }\n\n  &.vds-btn-label [class^='vds-icon']:first-child {\n    margin-right: .875rem;\n  }\n\n  .vds-btn-text--tertiary &.vds-btn-label [class^='vds-icon']:first-child {\n    margin-right: .625rem;\n  }\n\n  @-moz-document url-prefix() {\n    &.vds-btn-label {\n      padding: 0 .6875rem;\n    }\n  }\n";
};

var _default = styles;
exports.default = _default;